<template>
  <div class="page page--account" v-if="isLoggedIn">
    <div class="content">
      <div class="header">
        <h1>Old Listings</h1>
        <select v-model="minAge">
          <option :value="0">All</option>
          <option :value="0.5">6 months</option>
          <option :value="1">1 year</option>
          <option :value="1.5">1.5 year</option>
          <option :value="2">2 years</option>
          <option :value="3">3 years</option>
          <option :value="4">4 years</option>
          <option :value="5">5 years</option>
        </select>
        <select v-model="category">
          <option :value="null">All Categories</option>
          <option v-for="category in allCategories" :value="category" :key="category">{{category}}</option>
        </select>
        <select v-model="showSubCategory">
          <option :value="true">Sort by Subcategory</option>
          <option :value="false">Sort by Category</option>
        </select>
      </div>
      <div v-for="(listings, category) in listingsByCategory" :key="category">
        <h2 :id="category">{{category}}</h2>
        <div v-for="(subCategoryListings, subCategory) in listings" :key="subCategory">
          <h3>{{subCategory}}</h3>
          <div class="grid">
            <Listing v-for="listing in subCategoryListings" :key="listing.id" :latest="{listing}"/>
          </div>
          </div>
      </div>
    </div>
  </div>
  <div class="page page--account" v-else>
    <Login />
  </div>
</template>

<script>
import Login from '@/components/Login.vue';
import Listing from '@/components/Listing.vue';

export default {
  components: {
    Listing,
    Login,
  },
  data: () => ({
    listings: [],
    listingsByCategory: {},
    showSubCategory: true,
    category: null,
    minAge: 1,
  }),
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    allCategories() {
      if (!this.listings.listings) {
        return [];
      }
      return this.listings.listings.reduce((acc, listing) => {
        if (!acc.includes(listing.category)) {
          acc.push(listing.category);
        }
        return acc;
      }, []);
    },
  },
  async mounted() {
    this.listings = await this.$store.dispatch('fetchListings', {
      count: false,
      sort: 'date',
      order: 'asc',
      date: null,
      dateOperator: 'lt',
      brands: [],
      brandOperator: 'eq',
      condition: null,
      priceFilter: '',
      priceOperator: 'gt',
      department: null,
      category: null,
      subCategory: null,
    });
    this.update();
  },
  watch: {
    minAge() {
      this.update();
    },
    category() {
      this.update();
    },
    showSubCategory() {
      this.update();
    },
  },
  methods: {
    update() {
      if (!this.listings.listings) {
        return;
      }
      const now = new Date();
      const months = 12 * this.minAge;
      const date = new Date(now.setMonth(now.getMonth() - months));
      this.listingsByCategory = this.listings.listings.reduce((acc, listing) => {
        if (new Date(listing.date) < date) {
          if (this.category && listing.category !== this.category) {
            return acc;
          }
          if (!acc[listing.category]) {
            acc[listing.category] = {};
          }
          const subCategory = this.showSubCategory ? (listing.sub_category || 'Other') : 'All';
          if (!acc[listing.category][subCategory]) {
            acc[listing.category][subCategory] = [];
          }
          acc[listing.category][subCategory].push(listing);
        }
        return acc;
      }, {});
    },
  },
};
</script>
<style>
.header {
  display: flex;
  gap: 1em;
  align-items: center;
  flex-wrap: wrap;
}
.content {
  margin: 0 auto;
  padding: 0 1em;
  max-width: 960px;
}
select {
  font-size: 1em;
  height: 2.5em;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1em;
}
.grid .status__listing {
  grid-area: auto;
}
.grid .status__listing h2 {
  /* overflow ellipsis max two lines */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
